/**
 * Tạo game mới và các thao tác cấp game (đổi chính sách, ngưỡng).
 */
import { PHIEN_BAN_LUU_TRU } from './luu-tru.js';
import { layThamSo, layThamSoMoPhong } from './du-lieu.js';
import { matHangMo, nguongNhap } from './kho.js';
import { ngayMayHienTai, taoNhiemVuNgay } from './nhiem-vu.js';
import { boCucMacDinh } from './noi-that.js';
import type { HamRng } from './rng.js';
import type { ChinhSachGiaChon, DuLieuGame, TrangThaiGame } from './types.js';

/** Cài đặt mặc định trong game (M3: tiếp cận + âm thanh). */
export const CAI_DAT_MAC_DINH = {
  nhacBat: true,
  sfxBat: true,
  giamChuyenDong: false,
  hieuUngBat: true,
  coChu: 'vua' as const,
  tatRung: false,
};

/** Khởi tạo game mới: vốn P34, nhập đầy ngưỡng các món đang mở. */
export function taoGameMoi(
  duLieu: DuLieuGame,
  _rng: HamRng,
  ngayMay = ngayMayHienTai(),
): TrangThaiGame {
  const state: TrangThaiGame = {
    phienBanLuuTru: PHIEN_BAN_LUU_TRU,
    tongGioGame: 0,
    xu: layThamSo(duLieu, 'P34'),
    capCuaHang: 1,
    chinhSach: 'canBang',
    danhTieng: 1,
    nguoiChoi: { xp: 0, cap: 1 },
    kho: {},
    donHang: [],
    nguongRieng: {},
    khoanNo: 0,
    donLonDemNguoc: layThamSoMoPhong(duLieu, 'M09'),
    mocBanHangTiep: layThamSoMoPhong(duLieu, 'M11'),
    thongKe: {
      tongLaiGop: 0,
      tongLuong: 0,
      tongChiNangCap: 0,
      monDaBan: {},
      tongMonDaBan: 0,
      soLuotHetHang: 0,
      soDonLon: 0,
      soNvHoanThanh: 0,
      soDonHangDaDat: 0,
      soDonHangDaGiao: 0,
      lanChoNo: 0,
      soDonLonHoanThanh: 0,
      tongCocCaPhe: 0,
      soQuaTang: 0,
    },
    mocCap: [{ cap: 1, gioThuc: 0 }],
    mocCapNguoiChoi: [{ cap: 1, gioThuc: 0 }],
    boCuc: boCucMacDinh(1, duLieu),
    uidNoiThatTiep: 3,
    tutorialXong: false,
    // --- M3 ---
    khuHienTai: 'pho-cho',
    nhiemVuNgay: '',
    nhiemVu: [],
    donLon: null,
    npcThanThiet: {},
    npcQuaDaTang: {},
    thoiTiet: {},
    thanhTuuDaMo: [],
    xuCaoCap: 0,
    suuTapXong: [],
    cosmeticSoHuu: [],
    nhanVien: { thuNgan: false, xepKe: false },
    caPheTheoMon: {},
    caiDat: { ...CAI_DAT_MAC_DINH },
  };
  // Nhập đầy ngưỡng cho món mở (trừ vốn) — khớp kiểm tra 36 bảng tính.
  for (const m of matHangMo(state, duLieu)) {
    const nguong = nguongNhap(m.ma, state, duLieu);
    state.kho[m.ma] = { ton: nguong };
    state.xu -= nguong * m.giaVon;
  }
  // Nhiệm vụ hằng ngày cho ngày máy hiện tại.
  taoNhiemVuNgay(state, duLieu, ngayMay);
  return state;
}

/** Đổi chính sách giá. */
export function datChinhSach(state: TrangThaiGame, chinhSach: ChinhSachGiaChon): void {
  state.chinhSach = chinhSach;
}

/** Ghi đè ngưỡng nhập cho một món (undefined = xóa ghi đè). */
export function datNguongRieng(state: TrangThaiGame, ma: string, nguong: number | undefined): void {
  if (nguong === undefined) {
    delete state.nguongRieng[ma];
  } else {
    if (!Number.isInteger(nguong) || nguong < 0) {
      throw new Error(`Ngưỡng nhập phải là số nguyên ≥ 0, nhận được ${nguong}.`);
    }
    state.nguongRieng[ma] = nguong;
  }
}

/** Đặt ngưỡng nhập chung (undefined = về mặc định P09). */
export function datNguongChung(state: TrangThaiGame, nguong: number | undefined): void {
  if (nguong === undefined) {
    delete state.nguongChung;
    return;
  }
  if (!Number.isInteger(nguong) || nguong < 0) {
    throw new Error(`Ngưỡng nhập phải là số nguyên ≥ 0, nhận được ${nguong}.`);
  }
  state.nguongChung = nguong;
}
